import React, { useEffect, useState } from "react";
import Header from '../components/header';

function Status() {
  const [user, setUser] = useState(null);
  const [tracking, setTracking] = useState('');
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      try {
        const parsedUser = JSON.parse(storedUser);
        setUser(parsedUser);
      } catch (error) {
        console.error('Error parsing user data from localStorage', error);
        setUser(null);
      }
    }
  }, []);

  const handleSearch = async () => {
    if (!tracking) {
      setError('กรุณาใส่รหัส');
      setResult(null);
      return;
    }
  
    setLoading(true);
    setError('');
    setResult(null);
  
    await new Promise(resolve => setTimeout(resolve, 3000));
  
    try {    // const domain = "software.piyamanee.com";
      const url = "software.piyamanee.com";
      const response = await fetch(`https://${url}/server/fetch/search.php?tracking=${tracking}`);
        // const response = await fetch(`http://${url}/user_repairs_old/user_repairs/server/fetch/search.php?tracking=${tracking}`);
      const data = await response.json();
      if (data.error) {
        setError(data.error);
      } else {
        setResult(data);
      }
    } catch (err) {
      setError('เกิดข้อผิดพลาดในการเชื่อมต่อ');
    }
  
    setLoading(false);
  };
  

  return (
    <div>
      <Header />
      <div className='indexMain_ContentArea_Container' style={{ marginTop: "90px" }}>
        <div className='indexMain_ContentStatus'>
          <p>รหัสติดตาม - Tracking number</p>
          <div>
            <input
              type="text"
              className='form-control inputStatusSearch'
              placeholder='ใส่รหัสของคุณที่นี่...'
              value={tracking}
              onChange={(e) => setTracking(e.target.value)}
            />
          </div>
          <button className='indexMain_ContentStatusBtn' onClick={handleSearch}>
            <i className="fa-solid fa-magnifying-glass"></i> ค้นหา
          </button>
          
          <div class="accordion accordion-flush" id="accordionFlushExample">
            <div class="accordion-item">
                <h2 class="accordion-header">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                 ค้นหารหัสจากไหน?
                </button>
                </h2>
                <div id="flush-collapseOne" class="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
                    <div class="accordion-body">
                        <div>
                            <ul>
                                <li>1. เมื่อทำการแจ้งซ่อมสำเร็จ จะได้รหัสการแจ้ง <span style={{color:"red"}}>(โดยให้ปิดฟอร์มออกไป)</span></li>
                            </ul>
                            <div className='indexSearchModalContents'>
                                <img src="/src11.png" alt="src11" />
                            </div>
                        </div>
                        <div style={{marginTop:"10px"}}>
                            <ul>
                                <li>2. จะพบรหัสติดตามแสดงอยู่ด้านล่าง <span style={{color:"red"}}>(รหัสนี้ จะแสดงในทุกครั้งหลังจากมีการแจ้งสำเร็จ โปรดเก็บรหัสไว้เพื่อติดตามสถานะในทุกๆครั้ง)</span></li>
                            </ul>
                            <div className='indexSearchModalContents'>
                                <img src="/src12.png" alt="src11" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>

        {/* Spinner */}
        {loading && (
          <div className="d-flex justify-content-center" style={{ marginTop: "20px" }}>
            <div className="spinner-border text-primary" role="status" style={{ width: "1.5rem", height: "1.5rem" }}>
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        )}

        {/* Error Message */}
        {!loading && error && (
          <div className="error-box"><i class="fa-solid fa-circle-exclamation"></i> {error}</div>
        )}

        {/* Result Display */}
        {!loading && result && (
          <div className='indexMain_ContentStatus'>
            <p className='contentsStatusBorderBottom'>
              <i className="fa-solid fa-square-poll-vertical"></i> ผลลัพธ์ที่ตรงกัน - {result.list_id_type}
            </p>
            <div className='statusContentsFlex'>
              <div className='indexMain_ContentsStatusResult'>
                <div style={{ fontWeight: "500", fontSize: "14px", marginRight: "5px" }}> ชื่อ </div>
                <div style={{ fontWeight: "500", fontSize: "14px", color: "gray" }}>{result.list_username}</div>
              </div>
              <div className='indexMain_ContentsStatusResult'>
                <div style={{ fontWeight: "500", fontSize: "14px", marginRight: "5px" }}> วันที่แจ้ง </div>
                <div style={{ fontWeight: "500", fontSize: "14px", color: "gray" }}>{result.list_date_real}</div>
              </div>
              <div className='indexMain_ContentsStatusResult'>
                <div style={{ fontWeight: "500", fontSize: "14px", marginRight: "5px" }}> ประเภท </div>
                <div style={{ fontWeight: "500", fontSize: "14px", color: "gray" }}>
                    {
                    result.list_type == 1 ? "ช่าง" :
                    result.list_type == 2 ? "IT support" :
                    result.list_type == 3 ? "Programmer" :
                        "ไม่ระบุ"
                    }
                </div>
            </div>

            </div>
            <div style={{ marginTop: "5px" }} className='reasonResults'>
              <div className='indexMain_ContentsStatusResult reasonResultsGrid'>
                <div style={{ fontWeight: "500", fontSize: "14px", marginRight: "5px" }}> ปัญหา </div>
                <div style={{ fontWeight: "500", fontSize: "14px", color: "gray" }}>{result.list_reason}</div>
              </div>
            </div>

            <div style={{ marginTop: "22px" }}>
              <div className='indexMain_ContentsStatusResult' style={{ display: "grid", alignItems: "center" }}>
                <div style={{ fontWeight: "500", fontSize: "14px", marginRight: "5px" }}> สถานะ </div>
                    <div className="status-tracker">

                        <div className={`step ${['Waiting', 'Processing', 'Cancel', 'Success'].includes(result.list_status) ? 'active' : ''}`}>
                        <div className="circle"><i className="fa-solid fa-check"></i></div>
                        <div className="label">กำลังรอ</div>
                        </div>

                        <div className={`line ${['Processing', 'Cancel', 'Success'].includes(result.list_status) ? 'active' : ''}`}></div>

                        <div className={`step ${['Processing', 'Cancel', 'Success'].includes(result.list_status) ? 'active' : ''}`}>
                        <div className="circle"><i className="fa-solid fa-check"></i></div>
                        <div className="label">กำลังดำเนินการ</div>
                        </div>

                        <div className={`line ${result.list_status === 'Cancel' ? 'activeRed' : result.list_status === 'Success' ? 'active' : ''}`}></div>

                        <div className={`step ${result.list_status === 'Cancel' ? 'activeRed' : ''}`}>
                        <div className="circle"><i className="fa-solid fa-xmark"></i></div>
                        <div className="label">ยกเลิก</div>
                        </div>

                        <div className={`line ${result.list_status !== 'Cancel' && result.list_status === 'Success' ? 'active' : ''}`}></div>

                        <div className={`step ${result.list_status === 'Success' ? 'active' : ''}`}>
                        <div className="circle"><i className="fa-solid fa-check"></i></div>
                        <div className="label">สำเร็จ</div>
                        </div>

                    </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Status;